module.exports = __webpack_public_path__ + "static/media/image-3.928f0f4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/TextEditor/image-3.png
// module id = 272
// module chunks = 0